import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ScreenSize } from '../models/interfaces';
import { ScreenSizeNotifierService } from './screen-size-notifier.service';

@Injectable()
export class ScreenSizeObserverService implements OnDestroy {
	private smallScreenObserver$!: Observable<BreakpointState>;
	private largeScreenObserver$!: Observable<BreakpointState>;
	private fullScreenObserver$!: Observable<BreakpointState>;
	private mobileScreenObserver$!: Observable<BreakpointState>;

	private smallScreenSubscriber!: Subscription;
	private largeScreenSubscriber!: Subscription;
	private fullScreenSubscriber!: Subscription;
	private mobileScreenSubscriber!: Subscription;

	constructor(private observer: BreakpointObserver, private screenSizeNotifierService: ScreenSizeNotifierService) {
		// small screen observer
		this.smallScreenObserver$ = this.observer.observe(['(max-width: 700px)']);

		// large screen observer
		this.largeScreenObserver$ = this.observer.observe(['(max-width: 800px)']);

		// full screen (desktop and laptop screen observer)
		this.fullScreenObserver$ = this.observer.observe(['(min-width: 900px)']);

		// mobile screen observer
		this.mobileScreenObserver$ = this.observer.observe(['(max-width: 400px)']);
	}

	public subscribeSmallScreenUpdate() {
		this.smallScreenSubscriber = this.smallScreenObserver$.subscribe((event: any) => {
			if (event.matches) {
				let screenSize = ScreenSize.Small;
				this.screenSizeNotifierService.pushScreenSizeUpdateMessage(screenSize);
			}
		});
	}

	public subscribeLargeScreenUpdate() {
		this.largeScreenSubscriber = this.largeScreenObserver$.subscribe((event: any) => {
			if (event.matches) {
				let screenSize = ScreenSize.Large;
				this.screenSizeNotifierService.pushScreenSizeUpdateMessage(screenSize);
			}
		});
	}

	public subscribeFullScreenUpdate() {
		this.fullScreenSubscriber = this.fullScreenObserver$.subscribe((event: any) => {
			if (event.matches) {
				let screenSize = ScreenSize.XL;
				this.screenSizeNotifierService.pushScreenSizeUpdateMessage(screenSize);
			}
		});
	}

	public subscribeMobileScreenUpdate() {
		this.mobileScreenSubscriber = this.mobileScreenObserver$.subscribe((event: any) => {
			if (event.matches) {
				let screenSize = ScreenSize.Mobile;
				this.screenSizeNotifierService.pushScreenSizeUpdateMessage(screenSize);
			}
		});
	}

	ngOnDestroy(): void {
		this.smallScreenSubscriber.unsubscribe();
		this.fullScreenSubscriber.unsubscribe();
		this.largeScreenSubscriber.unsubscribe();
		this.mobileScreenSubscriber.unsubscribe();
	}
}
